import { ILobbyMatchPrep, ILobbyPlayerMatchPrep } from '@nova/types';

// * Segregated for file to be client-compatible

export function createLobby(
  player: ILobbyPlayerMatchPrep,
  lobbyId: string,
  browserIndex: number,
  lobbyName: string,
  playerCap: number,
  playableMatchConfigIds: string[]
): ILobbyMatchPrep {
  const lobby: ILobbyMatchPrep = {
    id: lobbyId,
    browserIndex: browserIndex,
    lobbyName,
    players: [player],
    playerCap,
    playableMatchConfigIds,
    highlightedMatchConfigId: playableMatchConfigIds[0],
    leader: player.id
  };

  return lobby;
}
